import { h } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
import ProductRecommendationSlide from './product-rec-slide';

const ProductRecommendations = ({
  productRecommendations,
  productRecommendationsHeading,
}) => (
  <section className="order-last border-t border-grey-300">
    <p class="subheading-3 my-4 desktop:my-5" role="heading">
      {productRecommendationsHeading}
    </p>
    <Swiper
      slidesPerView={1.25}
      spaceBetween={10}
      scrollbar={{ draggable: true }}
    >
      {productRecommendations.length
        && productRecommendations.map((product) => (
          <SwiperSlide
            key={`mini-cart-${product.id}`}
            tag="article"
            className="p-[.625rem] border border-grey-300 !h-auto"
          >
            <ProductRecommendationSlide product={product} />
          </SwiperSlide>
        ))}
    </Swiper>
  </section>
);

export default ProductRecommendations;
